module.exports = __webpack_public_path__ + "static/media/ImgENG.f9670136.svg";